import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=7a982634&scoped=true&"
import script from "./ProductsBlock.vue?vue&type=script&lang=ts&"
export * from "./ProductsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsBlock.vue?vue&type=style&index=0&id=7a982634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a982634",
  null
  
)

export default component.exports